import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Modal from "shared/react_components/Modal";
import { Button } from "reactstrap";

export default class ConfirmationModal extends React.Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    title: PropTypes.string,
    confirmText: PropTypes.string,
    confirmColor: PropTypes.string,
    cancelText: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    disableConfirm: PropTypes.bool,
    className: PropTypes.string
  };

  static defaultProps = {
    title: "Are you sure?",
    confirmText: "Yes",
    confirmColor: "primary",
    cancelText: "Cancel",
    disableConfirm: false,
    onConfirm: () => {},
    onCancel: () => {}
  };

  renderButtons = () => {
    return (
      <React.Fragment>
        <Button data-action="cancel" className="btn btn-secondary" onClick={this.props.onCancel}>
          {this.props.cancelText}
        </Button>
        <Button
          data-action="confirm"
          color={this.props.confirmColor}
          onClick={this.props.onConfirm}
          disabled={this.props.disableConfirm}
        >
          {this.props.confirmText}
        </Button>
      </React.Fragment>
    );
  };

  render() {
    return (
      <Modal
        isOpen={true}
        toggle={this.props.onCancel}
        title={this.props.title}
        className={classNames("no-overflow", this.props.className)}
        buttons={this.renderButtons()}
        large={false}
      >
        {this.props.children}
      </Modal>
    );
  }
}
